<template>
    <form class="cobalt-task-form" ref="componentWrapper" @clickOutside="onClickOutside" @submit.prevent="">
        <div class="np-input-group" :class="{'active' : this.isFocused}">
            <input 
                type="text" 
                ref="titleInput" 
                class="np-text-input" 
                :placeholder="this.$t('UI.task.add')" 
                :disabled="isLoading"  
                @focusin="focusIn"
                @keydown.enter.prevent="updateTask" 
                @keydown.esc="cancel"/>
            <div class="actions">
                <button type="button" class="np-btn np-btn-link np-mr-1" @click="cancel">
                    <svg><use href="@/assets/images/icons/cancel2.svg#icon"></use></svg>
                </button>
                <button type="button" class="np-btn np-btn-link" @click="updateTask" :disabled="isLoading">
                    <svg><use href="@/assets/images/icons/checked3.svg#icon"></use></svg>
                </button>                                                                                                
            </div>
        </div>
    </form>
</template>

<script>
import { ref } from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../../config.js'

export default {
    components: {
    },    
    props: {
        taskData: {
            type: Object,
            required: true
        },
        statusId: {
            type: Number,
            required: true
        }
    },    
    data() {
        return {
            Config,
            componentWrapper: null,
            titleInput: null,
            isFocused: false,
            isLoading: false
        }
    },
    mounted() {
        this.componentWrapper = this.$refs.componentWrapper;
        this.titleInput = this.$refs.titleInput;

        document.addEventListener('mouseup', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('mouseup', this.handleClickOutside);
    },
    methods: {
        ...mapActions('board', ['updatTsk']),

        focusIn() {
            this.isFocused = true
        },   
        cancel() {
            const input = this.titleInput;
            if (input) {
                input.value = ''
                input.blur()
                this.isFocused = false
            }
        },
        async updateTask() {
            this.taskData.status_id = this.statusId
            this.taskData.title = this.titleInput.value

            if (!this.taskData.title) return

            this.isLoading = true

            await this.updatTsk(this.taskData)

            this.cancel()
            
            await this.updTstts()

            this.$emit('scrollTop', this.statusId)
            
            this.isLoading = false
        },
        updTstts() {
            this.$emit('refresh')
        },
        handleClickOutside(event) {
            if (
                this.componentWrapper &&
                !this.componentWrapper.contains(event.target) &&
                event.target !== this.titleInput
            ) {
                this.cancel()
            }
        }        
    }
}
</script>

<style></style>